<template>
  <div>
    <b-row class="d-flex justify-content-center align-items-center">
      <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="my-5 text-left">
        <h3 class="d-flex align-items-center">
          <p class="current-step-icon">1</p>
          Adjon meg néhány adatot a cégéről
        </h3>
        <p>
          Válaszoljon a cégével és a finanszírozási céljával kapcsolatos kérdésekre, a pontosabb találatok érdekében.
        </p>
      </b-col>
      <b-col v-if="window.width > 576" cols="6">
        <img src="../../../assets/img/fundMap/fund-home-3.png" class="image-width" />
      </b-col>
    </b-row>

    <b-row class="d-flex justify-content-center align-items-center">
      <b-col v-if="window.width > 576" cols="6">
        <img src="../../../assets/img/fundMap/fund-home-2.png" class="image-width" />
      </b-col>
      <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="my-5 text-left">
        <h3 class="d-flex align-items-center">
          <p class="current-step-icon">2</p>
          Határozza meg céljait
        </h3>
        <p>
          Válassza ki a kategóriák és az alkategóriák közül, hogy milyen célra keres finanszírozási forrást. Csak azokat
          a kategóriákat látja, amelyek olyan termékeket tartalmaznak, amelyekre a cége adatai alapján jogosult lehet.
        </p>
      </b-col>
    </b-row>

    <b-row class="d-flex justify-content-center align-items-center">
      <b-col cols="12" sm="6" md="6" lg="6" xl="6" class="my-5 text-left">
        <h3 class="d-flex align-items-center">
          <p class="current-step-icon">3</p>
          Tekintse meg a forráslistát
        </h3>
        <p>
          Böngésszen a cégéhez és céljaihoz illeszkedő finanszírozási termékek között.
        </p>
      </b-col>
      <b-col v-if="window.width > 576" cols="6">
        <img src="../../../assets/img/fundMap/fund-home-1.png" class="image-width" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      window: {
        width: 0
      }
    }
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
.current-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  height: 56px;
  background-color: #00903c;
  color: #fff;
  border-radius: 50%;
  font-weight: 700;
  font-size: 32px;
  margin: 0;
  margin-right: 20px;
}

.image-width {
  max-width: 450px;
}
@media all and (max-width: 992px) {
  .image-width {
    max-width: 350px;
  }
}

@media all and (max-width: 767px) {
  .image-width {
    max-width: 250px;
  }
}
</style>
